'use client'

import type { Space } from '@cocoonspace/sdk-js/types/space'
import { useMemo } from 'react'
import { useLingui } from '@lingui/react/macro'

import type { OpeningHour } from '~/domains/spaces/hooks/get-concat-days-hours'
import { useSpaceHours } from '~/domains/spaces/hooks/use-space-hours.hook'

export const SpaceHoursContent = ({ hours }: { hours: OpeningHour[] }) => {
	const { t } = useLingui()

	const refDays = useMemo(() => {
		return {
			mon: t`Lun`,
			tue: t`Mar`,
			wed: t`Mer`,
			thu: t`Jeu`,
			fri: t`Ven`,
			sat: t`Sam`,
			sun: t`Dim`,
		}
	}, [t])

	return (
		<>
			{hours.map((spaceHour, i) => (
				<div
					className='flex flex-row gap-1'
					key={i}
				>
					<span>
						{`${[spaceHour.dayStart, spaceHour.dayEnd]
							.filter((el) => el)
							.map((day) => refDays[day as keyof typeof refDays])
							.join(' - ')} :`}
					</span>

					<span>
						{spaceHour.closed
							? t`Fermé`
							: spaceHour.open
									?.map((times) => [times.from, times.to].join(' - '))
									.join(', ')}
					</span>
				</div>
			))}
		</>
	)
}

export const SpaceHours = ({ space }: { space: Pick<Space, 'hours'> }) => {
	const { t } = useLingui()

	const { spaceHours } = useSpaceHours(space.hours)

	return (
		<div className='flex flex-col gap-2 text-sm'>
			<h2 className='font-bold'>{t`Horaires du Cocoon`}</h2>
			<SpaceHoursContent hours={spaceHours} />
		</div>
	)
}
